import { SearchInput } from "../../ui-kit/SearchInput"
import { AutocompleteInput } from "../../ui-kit/AutocompleteInput"
import { CheckboxInput } from "../../ui-kit/CheckboxInput"
import { TextInput } from "../../ui-kit/TextInput"
import { GRID_FORM_CONFIG_T } from "../../../common/FormGenerator"
import { USERS_FILTRATION } from "../../../consts/formOptions"
import { AgeStyled } from "./style"

export type FiltrationBlockName =
  | "query"
  | "city"
  | "age_from"
  | "age_to"
  | "status"
  | "competencies"
  | "availableResources"
  | "conditionsOfParticipation"

export const queryConfig = [
  [
    {
      id: 1,
      controllerName: "query",
      RenderElement: SearchInput,
      renderProps: () => ({
        placeholder: "Поиск...",
        fullWidth: true,
        inputProps: { maxLength: 32 },
      }),
    },
  ],
]

export const cityConfig = [
  [
    {
      id: 2,
      controllerName: "city",
      RenderElement: TextInput,
      renderProps: () => ({
        placeholder: "Введите город",
        fullWidth: true,
        htmlInputProps: { maxLength: 64 },
      }),
    },
  ],
]

export const ageFromConfig = [
  [
    {
      id: 3,
      controllerName: "age_from",
      RenderElement: AutocompleteInput,
      renderProps: ({ formValues }: { formValues: Record<string, unknown> }) => {
        const ageTo = formValues?.age_to
        const toNum = ageTo !== undefined && ageTo !== "" && ageTo !== null
          ? Number(ageTo)
          : null
        const options =
          toNum !== null && !Number.isNaN(toNum)
            ? USERS_FILTRATION.AGE_FROM.filter(
                (opt) => Number(opt.value) <= toNum
              )
            : [...USERS_FILTRATION.AGE_FROM]
        return {
          placeholder: "От",
          options,
          fullWidth: true,
          sx: AgeStyled,
        }
      },
    },
  ],
]

export const ageToConfig = [
  [
    {
      id: 4,
      controllerName: "age_to",
      RenderElement: AutocompleteInput,
      renderProps: ({ formValues }: { formValues: Record<string, unknown> }) => {
        const ageFrom = formValues?.age_from
        const fromNum = ageFrom !== undefined && ageFrom !== "" && ageFrom !== null
          ? Number(ageFrom)
          : null
        const options =
          fromNum !== null && !Number.isNaN(fromNum)
            ? USERS_FILTRATION.AGE_TO.filter(
                (opt) => Number(opt.value) >= fromNum
              )
            : [...USERS_FILTRATION.AGE_TO]
        return {
          placeholder: "До",
          options,
          fullWidth: true,
          sx: AgeStyled,
        }
      },
    },
  ],
]

export const statusConfig = [
  [
    {
      id: 5,
      controllerName: "status",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: USERS_FILTRATION.STATUS,
        fullWidth: true,
      }),
    },
  ],
]

export const competenciesConfig = [
  [
    {
      id: 6,
      controllerName: "competenciesUser",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: USERS_FILTRATION.COMPETENCIES,
        fullWidth: true,
      }),
    },
  ],
]

export const availableResourcesConfig = [
  [
    {
      id: 7,
      controllerName: "information",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Информационные",
      }),
    },
  ],
  [
    {
      id: 8,
      controllerName: "intelligent",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Интеллектуальные",
      }),
    },
  ],
  [
    {
      id: 9,
      controllerName: "labor",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Трудовые",
      }),
    },
  ],
  [
    {
      id: 10,
      controllerName: "financial",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Финансовые",
      }),
    },
  ],
  [
    {
      id: 11,
      controllerName: "transportLogistics",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Транспортно-логистические",
      }),
    },
  ],
  [
    {
      id: 12,
      controllerName: "immovable",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Недвижимые",
      }),
    },
  ],
]

export const conditionsOfParticipationConfig = [
  [
    {
      id: 13,
      controllerName: "freeOfCharge",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Безвозмездное",
      }),
    },
  ],
  [
    {
      id: 14,
      controllerName: "paid",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Возмездное",
      }),
    },
  ],
  [
    {
      id: 15,
      controllerName: "partiallyCompensated",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Частично-возмездное",
      }),
    },
  ],
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
  query: queryConfig,
  city: cityConfig,
  age_from: ageFromConfig,
  age_to: ageToConfig,
  status: statusConfig,
  competencies: competenciesConfig,
  availableResources: availableResourcesConfig,
  conditionsOfParticipation: conditionsOfParticipationConfig,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]